// TODO: move to .env
const PROD_API_BASE_URL = 'https://dev-api.tidydata.co/v1';

// TODO: remove PROD
export const API_BASE_URL = PROD_API_BASE_URL || process.env.REACT_APP_API_BASE_URL;
export const SNOWFLAKE_URL = 'snowflakecomputing.com';
